module.exports = __webpack_public_path__ + "static/img/jxcb614.b73ea36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxcb614.png
// module id = tY+e
// module chunks = 73